import { render, staticRenderFns } from "./DlsTjf.vue?vue&type=template&id=20b97034"
import script from "./DlsTjf.vue?vue&type=script&lang=js"
export * from "./DlsTjf.vue?vue&type=script&lang=js"
import style0 from "./DlsTjf.vue?vue&type=style&index=0&id=20b97034&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports